<template>
    <div class="radio-button" :aria-label="name +' '+ $t('options')">
        <div
            class="form-check mb-3 radio_wrapper"
            v-for="(option, index) in this.options"
            :key="index"
        >
            <input
                class="form-check-input radio-custom"
                type="radio"
                :name="name"
                :value="option.value"
                v-model="currentValue"
                :id="`radio-button-${name}-${index}`"
                hidden
                :disabled="disabledButtons"
            />
            <div class="radio-section d-flex justify-content-start align-items-center" :class="{ disabled: disabledButtons }" @click="changeValue(option.value)">
                <div class="check-mark">
                    <div
                        class="rounded-circle"
                        :class="{
                            radio_wrapper_checked: currentValue == option.value,
                            radio_wrapper_unchecked: currentValue != option.value,
                            disabled: disabledButtons
                        }"
                        :style="'--category-color:' + categoryInfo.color"
                    >
                        <font-awesome-icon
                            class="check"
                            :icon="['fas', 'check']"
                            :class="{ hidden: currentValue != option.value }"
                        />
                    </div>
                </div>
                <div class="check-label">
                    <label
                        :aria-labelledby="option.label.replace(/\s+/g,'-')"
                        class="form-check-label radio-custom-label text-white label"
                        :for="`radio-button-${name}-${index}`"
                        :class="{ label_checked: currentValue == option.value, disabled: disabledButtons }"
                        :style="'--category-color:' + categoryInfo.color"
                    >
                        {{ option.label }}
                    </label>
                    <div :id="option.label.replace(/\s+/g,'-')"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

// Import helpers
import { Default }  from '@/helpers/Default.js';
import { EventBus } from '@/helpers/EventBus.js';

export default {
    props: ["name", "options", 'selectedOption'],
    data() {
        return {
            currentValue:     null,
            categoryInfo:     Default.categories[this.name],
            animationsToggle: Default.animationsToggle,
            disabledButtons:  true
        };
    },
    mounted() {
        if (this.selectedOption) {
            this.currentValue = this.selectedOption;
        } else if (this.options.length > 0) {
            this.selectFirstOption();
        }

        if (this.$session.has('animationsToggle')) {
            this.animationsToggle = this.$session.get('animationsToggle');
        }

        if (this.animationsToggle) {
            setTimeout(() => {
                this.disabledButtons = false;
            }, 2000);
        } else {
            this.disabledButtons = false;
        }

        // Listen for OpenDyslexic font setting value
        EventBus.$on('settingsChanged', (setting) => {
            this[setting.name] = setting.value;
        });

        EventBus.$on('changeOptionFromModal', (event) => {
            this.currentValue = event;
        });
    },
    watch: {
        options () {
            if (this.options.length > 0) {
                this.selectFirstOption();
            }
        }
    },
    methods: {
        /**
         * Once the component loaded select the first option
         */
        selectFirstOption () {
            this.currentValue = this.options[0].value;
            this.$emit('changeOption', this.currentValue);
        },

        /**
         * Change the value of the radio buttons and set it in the session
         *
         * @param {string} value The value of radio button
         */
        changeValue(value) {
            if (this.disabledButtons) {
                return;
            }

            this.currentValue = value;
            this.$emit('changeOption', this.currentValue);

            if (this.animationsToggle) {
                this.disabledButtons = true;
                setTimeout(() => {
                    this.disabledButtons = false;
                }, 2000);
            }
        },
    },
};
</script>
